import { render } from "./CardRequest.vue?vue&type=template&id=3c04ef5c&scoped=true"
import script from "./CardRequest.vue?vue&type=script&lang=js"
export * from "./CardRequest.vue?vue&type=script&lang=js"

import "./CardRequest.vue?vue&type=style&index=0&id=3c04ef5c&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c04ef5c"]])

export default __exports__